export default __webpack_public_path__ + "5ab847bb0580fd0bc52d04f6cfeb6b88.png";